import { AxiosResponse } from 'axios'
import { IOnChangeUnidadeGestora } from 'components/UnidadeGestoraFields'
import { IGenericEntityResponse } from 'services/core/entityResponseCore'
import { RequestREAD } from 'services/Instances'

export const ReportsEffectivesNGTServices = () => {
  const path = 'RelatoriosEfetivo'

  const FillCards = async (
    body: IFillCardsBody
  ): Promise<AxiosResponse<IFillCardsResponse>> =>
    await RequestREAD.post(`${path}/FillCards`, body)

  const FillCardsGeneric = async (
    body: IFillCardsBody
  ): Promise<AxiosResponse<IFillCardsGenericResponse>> =>
    await RequestREAD.post(`${path}/FillCards`, body)

  const ContratoTTL = async (

    body: IFillCardsBody
  ): Promise<AxiosResponse<IGenericEntityResponse<IRelatorioTtl>>> =>
    await RequestREAD.post(`${path}/ContratoTTL`, body)



  const FornecedorTTL = async (
    body: IFillCardsBody
  ): Promise<AxiosResponse<IGenericEntityResponse<IRelatorioTtl>>> =>
    await RequestREAD.post(`${path}/FornecedorTTL`, body)

  const ContratoHHT = async (
    body: IFillCardsBody
  ): Promise<AxiosResponse<IGenericEntityResponse<IRelatorioHht>>> =>
    await RequestREAD.post(`${path}/ContratoHHT`, body)

  const FornecedorHHT = async (
    body: IFillCardsBody
  ): Promise<AxiosResponse<IGenericEntityResponse<IRelatorioHht>>> =>
    await RequestREAD.post(`${path}/FornecedorHHT`, body)

  const RelatorioExcel = async (
    body: any,
    name: string
  ): Promise<AxiosResponse<IFillCardsResponse>> =>
    await RequestREAD.post(`${path}/${name}/RelatorioExcel`, body, {
      headers: {
        'fLTodos': localStorage.getItem("fLTodos")

      }
    })

  const ViewReport = async () => await {}

  return {
    ContratoHHT,
    ContratoTTL,
    FillCards,
    FillCardsGeneric,
    FornecedorHHT,
    FornecedorTTL,
    RelatorioExcel,
    ViewReport
  }
}

interface IFillCardsBody {
  relatorioTTL?: boolean
  tipoContrato?: boolean
  competenciaDataIni?: Date | string
  competenciaDataFim?: Date | string
  cdContrato?: string
  contratosIds?: number[]
  nmFornecedor?: string
  fornecedoresIds?: number[]
  nmEmpresa?: string
  nmSubcontratada?: string
  empresasIds?: number[]
  nmCentro?: string
  isHht?: boolean
  centrosIds?: number[]
  subcontratadasIds?: number[]
  unidadeGestoraId?: IOnChangeUnidadeGestora
  flTodos?: boolean
  flValidacaoAnalista?: boolean
  flValidacaoContraparte?: boolean
  flStatusMovimentacao?: boolean
}

export interface IFillCardsGenericResponse {
  entity: IFillCardsResponse
}

export interface IFillCardsResponse {
  contratos: { id: number; name: string; checked: boolean }[]
  fornecedores: { id: number; name: string; checked: boolean }[]
  empresas: { id: number; name: string; checked: boolean }[]
  centros: { id: number; name: string; checked: boolean }[]
  subFornecedores?: { id: number; name: string; checked: boolean }[]
  subcontratadas?: { id: number; name: string; checked: boolean }[]
}

// Core
export interface Grupo<TGrupoItens> {
  content: any
  chaveGrupo: string
  grupoItens: TGrupoItens[]
}

// Relatorio TTL

export interface IRelatorioTtl {
  grupos: Grupo<GrupoIten>[]
  totalGeral: TotalGeral
}

export interface GrupoIten {
  grupo?: string
  cdContrato?: string
  nmFornecedor?: string
  dataCompInicio?: string
  dataCompFim?: string
  diretoriaExecutiva?: string
  diretoria?: string
  gerenciaGeral?: string
  gerencia?: string
  competencia?: string
  flStatusMobilizacao?: string
  nmContraparte?: string
  qtAtivo: number
  qtDemitido: number
  qtAcesso: number
  qtTransferido: number
  qtAfastado: number
  qtCompartilhado: number
  qtTotalEfetivoSemDemitido: number
  qtTotalEfetivoComDemitido: number
  progressoMovimentacao?: string
}

export interface TotalGeral {
  grupo: string
  cdContrato?: string
  nmFornecedor?: string
  dataCompInicio?: string
  dataCompFim?: string
  diretoriaExecutiva?: string
  diretoria?: string
  gerenciaGeral?: string
  gerencia?: string
  competencia?: string
  flStatusMobilizacao?: string
  qtAtivo: number
  qtDemitido: number
  qtAcesso: number
  qtTransferido: number
  qtAfastado: number
  qtCompartilhado: number
  qtTotalEfetivoSemDemitido: number
  qtTotalEfetivoComDemitido: number
}

// Relatorio HHT

export interface IRelatorioHht {
  grupos: Grupo<GrupoItenHht>[]
  totalGeral: TotalGeralHht
}

export interface GrupoItenHht {
  grupo?: string
  cdContrato?: string
  nmFornecedor?: string
  de?: string
  dir: string
  gg: string
  ger: string
  mesAno?: string
  qtdHht: number
  qtdHe: number
  percentHeAnterior: number
  percentHe: number
  justifQtdHe?: string
  justificativaNumeroEfetivos: string
  justificativaVlrContratada: string
  percentHeHht: number
  percentHeHhtAnterior: number
  salBaseTotal: number
  folhaPgtoTotal: number
  qtTotalEfetivoSemDemitido: number
  qtTotalEfetivoComDemitido: number
  mesAnoAnterior?: string
  salBaseTotalAnterior: number
  folhaPgtoTotalAnterior: number
  qtdHhtAnterior: number
  qtdHeAnterior: number
  efetivoTotalAnterior: number
  dataCompIni?: string | Date
  dataCompFim?: string | Date
}

export interface TotalGeralHht {
  grupo: string
  cdContrato?: string
  nmFornecedor?: string
  de: string
  dir: string
  gg: string
  ger: string
  mesAno: string
  qtdHht: number
  qtdHe: number
  percentHeAnterior: number
  percentHe: number
  justifQtdHe: string
  justificativaNumeroEfetivos: string
  justificativaVlrContratada: string
  percentHeHht: number
  percentHeHhtAnterior: number
  salBaseTotal: number
  folhaPgtoTotal: number
  qtTotalEfetivoSemDemitido: number
  qtTotalEfetivoComDemitido: number
  mesAnoAnterior: string
  salBaseTotalAnterior: number
  folhaPgtoTotalAnterior: number
  qtdHhtAnterior: number
  qtdHeAnterior: number
  efetivoTotalAnterior: number
  dataCompIni: string | Date
  dataCompFim: string | Date
}
